import styled from 'styled-components';

export default styled.div`
  margin-right: 1rem;

  &:last-child {
    margin-right: 0;
  }
`;
